// extracted by mini-css-extract-plugin
export default {"recos":"S3-z","productCardOverride":"T3-z","rowHasBadge":"U3-z"};